import {useEffect, useState} from 'react'
import {Button, Form, Modal} from 'react-bootstrap'

type Props = {
  show: boolean
  onHide: () => void
  onSubmit: (payload: {contactId: string; metadata?: Record<string, any>; channelOverrides?: Record<string, any>}) => Promise<void>
  loading?: boolean
  campaignName?: string
}

export const AddTargetModal = ({show, onHide, onSubmit, loading, campaignName}: Props) => {
  const [contactId, setContactId] = useState('')
  const [metadataJson, setMetadataJson] = useState('{}')
  const [channelOverridesJson, setChannelOverridesJson] = useState('{}')

  useEffect(() => {
    if (!show) {
      setContactId('')
      setMetadataJson('{}')
      setChannelOverridesJson('{}')
    }
  }, [show])

  const parseJSON = (value: string) => {
    try {
      const parsed = JSON.parse(value || '{}')
      return parsed && typeof parsed === 'object' ? parsed : {}
    } catch (error) {
      return {}
    }
  }

  const handleSubmit = async () => {
    await onSubmit({
      contactId,
      metadata: parseJSON(metadataJson),
      channelOverrides: parseJSON(channelOverridesJson),
    })
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Add target {campaignName ? `to ${campaignName}` : ''}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className='mb-4'>
          <Form.Label>Contact ID</Form.Label>
          <Form.Control value={contactId} onChange={(event) => setContactId(event.target.value)} placeholder='Contact database ID' />
        </Form.Group>
        <Form.Group className='mb-4'>
          <Form.Label>Metadata (JSON)</Form.Label>
          <Form.Control as='textarea' rows={4} value={metadataJson} onChange={(event) => setMetadataJson(event.target.value)} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Channel overrides (JSON)</Form.Label>
          <Form.Control
            as='textarea'
            rows={4}
            value={channelOverridesJson}
            onChange={(event) => setChannelOverridesJson(event.target.value)}
          />
          <Form.Text muted>Use this to supply overrides like contact-specific WhatsApp numbers.</Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='light' onClick={onHide} disabled={loading}>
          Cancel
        </Button>
        <Button variant='primary' onClick={handleSubmit} disabled={loading || !contactId}>
          Add target
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
